import * as React from 'react';
import PropTypes from 'prop-types';

const SvgSportsHikeNormalLarge = React.forwardRef(
  ({ color, size, title, titleId, ...props }, ref) => (
    <svg
      fill={color}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 48 48"
      ref={ref}
      width={size}
      height={size}
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <path
        d="M16.17 41.13l.51-.51a2.145 2.145 0 012.96 0l.52.53A6.323 6.323 0 0024.64 43h2.4l-1.44-2h-.96a4.287 4.287 0 01-3.06-1.27l-.53-.52a4.083 4.083 0 00-4.455-.888 4.082 4.082 0 00-1.325.888l-.52.51A4.31 4.31 0 0111.66 41H10.4l-1.44 2h2.7a6.33 6.33 0 004.51-1.87zM32.54 43l-1.44-2h-3.03l1.44 2h3.03z"
        fill=""
      />
      <path
        d="M5.52 43h.97l1.44-2H5.52A3.525 3.525 0 012 37.48c0-.49.01-.99.05-1.48h25.44l-1.45-2H2.25c.06-.42.13-.83.21-1.24l1.27-6.54a6 6 0 012.95-4L21 14.23v-2.3L5.7 20.48a7.005 7.005 0 00-.98.66l.59-3.03a5.353 5.353 0 012.67-3.67l6.79-3.75 1.17-2.33A2.457 2.457 0 0118.15 7a4.842 4.842 0 014.48 3c.12.28.21.571.27.87.068.322.102.65.1.98v14.46l1.37.73L28 24.78v4.19l1.37.73L33 27.53v4.1l1.36.73 5.9-3.36h3.42A2.323 2.323 0 0146 31.32a9.7 9.7 0 01-7.17 9.35l1.23 1.71A11.7 11.7 0 0048 31.32 4.328 4.328 0 0043.68 27h-3l-13.44-7.14A4.232 4.232 0 0125 16.13v-4.28A6.854 6.854 0 0018.15 5a4.46 4.46 0 00-4 2.46l-.89 1.77-6.25 3.46a7.3 7.3 0 00-3.66 5.04L.49 32.37A27.392 27.392 0 000 37.48 5.53 5.53 0 005.52 43zM35 26.25l3.14 1.66L35 29.7v-3.45zm-5-2.66l3 1.59v.02L30 27v-3.41zm-5-2.89c.39.363.828.673 1.3.92l1.61.86L25 24.29V20.7z"
        fill=""
      />
      <path
        d="M37.96 42.89l-1.37-1.9c-.09.008-.18.012-.27.01h-2.75l1.44 2h1.31a12.668 12.668 0 001.64-.11z"
        fill=""
      />
    </svg>
  )
);
SvgSportsHikeNormalLarge.defaultProps = {
  color: 'currentColor',
  size: 48,
  title: undefined,
  titleId: undefined
};
SvgSportsHikeNormalLarge.propTypes = {
  color: PropTypes.string,
  size: PropTypes.number,
  title: PropTypes.string,
  titleId: PropTypes.string
};
export default SvgSportsHikeNormalLarge;
